<nav #navbar class="bg-white shadow-lg shadow-black/15 fixed top-0 p-[5px] w-full z-50">
  <div class="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12">
    <div class="flex justify-between items-center h-20 relative main-nav-container">


      <div class="hidden md:flex items-center space-x-12 desktop-view">
        <a routerLink="/home" routerLinkActive="active"
          class="nav-item text-gray-700 hover:text-[#731346] px-3 py-2 text-lg transition-colors duration-300">
          <span class="fas fa-home"></span> Home
        </a>
        <a routerLink="/products" routerLinkActive="active"
          class="nav-item text-gray-700 hover:text-[#731346] px-3 py-2 text-lg transition-colors duration-300">
          <span class="fas fa-shopping-bag"></span> Products
        </a>
        <a routerLink="/gallery" routerLinkActive="active"
          class="nav-item text-gray-700 hover:text-[#731346] px-3 py-2 text-lg transition-colors duration-300">
          <span class="fas fa-image"></span> Gallery
        </a>
      </div>

      <a routerLink="/" routerLinkActive="active">
        <div
          class="absolute left-1/2 top-0 transform -translate-x-1/2 translate-y-3 hidden md:flex items-center bg-white rounded-2xl p-5 shadow-lg shadow-black/15 border-2 border-white desktop-view">
          <img src="assets/img/Royal-International-logo.png" alt="Royal Beauty Cream"
            class="w-[170px] h-auto drop-shadow-md">
        </div>
      </a>


      <div class="hidden md:flex items-center space-x-8 desktop-view">
        <a routerLink="/about" routerLinkActive="active"
          class="nav-item text-gray-700 hover:text-[#731346] px-3 py-2 text-lg transition-colors duration-300">
          <span class="fas fa-info-circle"></span> About
        </a>
        <a routerLink="/contact" routerLinkActive="active"
          class="nav-item text-gray-700 hover:text-[#731346] px-3 py-2 text-lg transition-colors duration-300">
          <span class="fas fa-phone"></span> Contact
        </a>
        <a routerLink="/products"
          class="cta-btn bg-gradient-to-bl from-pink-700 to-pink-900 text-white px-5 py-2 rounded-xl font-medium hover:shadow-lg transition-all duration-300 transform hover:-translate-y-0.5">
          <span class="fas fa-cart-plus"></span> Shop Now
        </a>
      </div>


      <div class="flex md:hidden justify-between items-center w-full px-2 mobile-view">
        <a routerLink="/" routerLinkActive="active">
          <div class="flex items-center space-x-3">
            <img src="assets/img/Royal-International-logo.png" alt="Royal Beauty Cream" class="w-[170px] h-auto">
          </div>
        </a>
        <button (click)="toggleMobileMenu()" #mobileButton
          class="text-gray-700 hover:text-[#731346] focus:outline-none focus:text-[#731346] transition-colors duration-300">
          <i class="fas fa-bars text-4xl"></i>
        </button>
      </div>

    </div>

    <!-- Medium screen navigation (768px to 1090px) - Logo left, Menu right, One line -->
    <div
      class="hidden md:flex lg:hidden w-full justify-between items-center px-6 py-2 border-t border-gray-100 medium-nav">
      <!-- Logo on left -->
      <a routerLink="/" routerLinkActive="active">
        <img src="assets/img/Royal-International-logo.png" alt="Royal Beauty Cream" class="w-[200px]">
      </a>

      <!-- Navigation menu on right - all in one line -->
      <div class="flex items-center space-x-2 flex-nowrap">
        <a routerLink="/home" routerLinkActive="active"
          class="nav-item text-gray-700 hover:text-[#731346] px-2 py-1.5 text-sm transition-colors duration-300 whitespace-nowrap">
          <span class="fas fa-home mr-1"></span>Home
        </a>
        <a routerLink="/products" routerLinkActive="active"
          class="nav-item text-gray-700 hover:text-[#731346] px-2 py-1.5 text-sm transition-colors duration-300 whitespace-nowrap">
          <span class="fas fa-shopping-bag mr-1"></span>Products
        </a>
        <a routerLink="/gallery" routerLinkActive="active"
          class="nav-item text-gray-700 hover:text-[#731346] px-2 py-1.5 text-sm transition-colors duration-300 whitespace-nowrap">
          <span class="fas fa-image mr-1"></span>Gallery
        </a>
        <a routerLink="/about" routerLinkActive="active"
          class="nav-item text-gray-700 hover:text-[#731346] px-2 py-1.5 text-sm transition-colors duration-300 whitespace-nowrap">
          <span class="fas fa-info-circle mr-1"></span>About
        </a>
        <a routerLink="/contact" routerLinkActive="active"
          class="nav-item text-gray-700 hover:text-[#731346] px-2 py-1.5 text-sm transition-colors duration-300 whitespace-nowrap">
          <span class="fas fa-phone mr-1"></span>Contact
        </a>
        <a routerLink="/products"
          class="cta-btn bg-gradient-to-bl from-pink-700 to-pink-900 text-white px-4 py-1.5 rounded-xl text-sm font-medium hover:shadow-lg transition-all duration-300 whitespace-nowrap">
          <span class="fas fa-cart-plus mr-1"></span>Shop Now
        </a>
      </div>
    </div>
  </div>


  <div #mobileMenu class="mobile-menu md:hidden">
    <div class="px-4 pt-2 pb-3 space-y-0">
      <a (click)="navigateAndClose('/home')"
        class="mobile-nav-item block text-gray-700 hover:text-[#731346] text-base font-medium transition-colors duration-300 cursor-pointer">
        <span class="fas fa-home mr-2"></span> Home
      </a>
      <a (click)="navigateAndClose('/products')"
        class="mobile-nav-item block text-gray-700 hover:text-[#731346] text-base font-medium transition-colors duration-300 cursor-pointer">
        <span class="fas fa-shopping-bag mr-2"></span> Products
      </a>
      <a (click)="navigateAndClose('/gallery')"
        class="mobile-nav-item block text-gray-700 hover:text-[#731346] text-base font-medium transition-colors duration-300 cursor-pointer">
        <span class="fas fa-image mr-2"></span> Gallery
      </a>
      <a (click)="navigateAndClose('/about')"
        class="mobile-nav-item block text-gray-700 hover:text-[#731346] text-base font-medium transition-colors duration-300 cursor-pointer">
        <span class="fas fa-info-circle mr-2"></span> About
      </a>
      <a (click)="navigateAndClose('/contact')"
        class="mobile-nav-item block text-gray-700 hover:text-[#731346] text-base font-medium transition-colors duration-300 cursor-pointer">
        <span class="fas fa-phone mr-2"></span> Contact
      </a>
      <div class="pt-4 pb-3 px-4">
        <a (click)="navigateAndClose('/products')"
          class="w-full bg-gradient-to-r from-pink-700 to-pink-900 text-white px-4 py-3 rounded-lg font-medium hover:shadow-lg transition-all duration-300 cursor-pointer block text-center">
          <span class="fas fa-cart-plus"></span> Shop Now
        </a>
      </div>
    </div>
  </div>
</nav>
<app-whatsapp-float
  [phoneNumber]="'923369949494'" 
  [message]="'Hello! I\'m interested in your services and would like to know more.'"
  [position]="'bottom-right'"
  [showLabel]="true"
  [labelText]="'Need Help? Chat on WhatsApp'"
  [enablePulse]="true"
  [showOnlyInHours]="false">
</app-whatsapp-float>

<router-outlet></router-outlet>

<app-footer></app-footer>